import { useEffect, useState } from 'react';
import NotificationToast from '../components/elements/NotificationToast';

export const jiraChannel = new BroadcastChannel('gainss-jira-sync');

export const JiraBroadcastListener = () => {
  const [toast, setToast] = useState(null);

  useEffect(() => {
    const handleJiraBroadcast = (event) => {
      const { type, projectId } = event.data || {};

      if (type !== 'JIRA_CONFIG_CHANGED') return;

      if (
        projectId &&
        !window.location.pathname.includes(`/project/${projectId}`)
      ) {
        return;
      }

      setToast({
        id: Date.now(),
        type: 'success',
        message: 'Jira integration updated. Reloading page...',
      });

      setTimeout(() => {
        window.location.reload();
      }, 1000);
    };

    jiraChannel.addEventListener('message', handleJiraBroadcast);
    return () =>
      jiraChannel.removeEventListener('message', handleJiraBroadcast);
  }, []);

  if (!toast) return null;

  return (
    <NotificationToast
      id={toast.id}
      type={toast.type}
      message={toast.message}
      autoHideDuration={5000}
      onClose={() => setToast(null)}
    />
  );
};